export const meetupDate = '2025-05-23';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'ai-and-china-roadshow-2025-amsterdam';

export const initialCoordinates = {
  lat: 52.379635941113186,
  lng: 4.922375566461339,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'AI, Data and Trade War: Lessons From China',
  address: 'Hotel Jakarta, Javakade 766, 1019 SH Amsterdam, The Netherlands',
  link: 'https://maps.app.goo.gl/vRXpDXYrv2e2uU7L9',
};
